import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';
import PhdFormBuilder from '../PhdFormBuilder';
import PhdHelpHint from '../../../../common/Phd/PhdHelpHint.jsx';

const PhdStudyFieldsEditForm = ({ isSubmitting }) => {
  const { t } = useTranslation();

  const sections = useMemo(
    () => [
      {
        key: 'basic',
        title: t('Základné údaje'),
        fields: [
          {
            name: 'study_field',
            label: (
              <span>
                {t('Študijný program')}
                <PhdHelpHint
                  label={t('Čo znamená študijný program?')}
                  title={t(
                    'Názov programu zobrazovaný pri doktorandoch, témach a dokumentoch.',
                  )}
                />
              </span>
            ),
            type: 'text',
            rules: [required(t)],
            colSpan: 12,
          },
          {
            name: 'code',
            label: t('Kód programu'),
            type: 'text',
            rules: [required(t)],
            colSpan: 12,
          },
          {
            name: 'focus',
            label: (
              <span>
                {t('Študijný odbor')}
                <PhdHelpHint
                  label={t('Čo znamená študijný odbor?')}
                  title={t(
                    'Užšie odborné zameranie programu. Používa sa pri pracovnej skupine a odborovom scope tém.',
                  )}
                />
              </span>
            ),
            type: 'text',
            colSpan: 12,
          },
        ],
      },
    ],
    [t],
  );

  return (
    <PhdFormBuilder
      sections={sections}
      submitKey="phd-study-fields"
      isSubmitting={isSubmitting}
    />
  );
};

export default PhdStudyFieldsEditForm;
